/**
 * @fileoverview GET handler for the "/data_objects/:type_name/:object_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameObjectId } from "./constants";
import type { GetCustomObjectsTypeNameObjectIdResult } from "./types";
import { isGetCustomObjectsTypeNameObjectIdResult } from "./validators";

export const getCustomObjectsTypeNameObjectId = reactQueryFetcherAdapter(
  customObjectsTypeNameObjectId,
  (signal: AbortSignal, typeName: string, objectId: string): Promise<GetCustomObjectsTypeNameObjectIdResult> => {
    return fetch(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(objectId)}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsTypeNameObjectIdResult
);
